import assetActionService from "../../../../services/assetService/assetActionService/assetActionService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETACTIONS } from "../../../../utils/constants";
import { AssetActionInterface } from "../../../../models/AssetModel/AssetAction/AssetAction";

interface DeleteAssetActionContext {
  previousAssetActions: AssetActionInterface[];
  deletedAssetAction: AssetActionInterface | undefined;
}

const useDeleteAssetAction = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the assetAction to delete
    DeleteAssetActionContext
  >({
    mutationFn: assetActionService.Remove, // Remove should take a string ID

    onMutate: (assetActionId: string) => {
      const previousAssetActions =
        queryClient.getQueryData<AssetActionInterface[]>([
          CACHE_KEY_ASSETACTIONS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetActionInterface[]>(
        [CACHE_KEY_ASSETACTIONS, page, pageSize],
        previousAssetActions.filter(
          (assetAction) => assetAction.id !== assetActionId
        ) // Use assetActionId to filter
      );

      return {
        previousAssetActions,
        deletedAssetAction: previousAssetActions.find(
          (assetAction) => assetAction.id === assetActionId
        ),
      };
    },

    onError: (error, assetActionId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetActionInterface[]>(
        [CACHE_KEY_ASSETACTIONS, page, pageSize],
        context.previousAssetActions
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAssetAction;
